/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Time: { input: any; output: any; }
};

export enum AvailabilityStatus {
  Available = 'AVAILABLE',
  NotAvailable = 'NOT_AVAILABLE'
}

export enum AvailabilityType {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  PublicAndPrivate = 'PUBLIC_AND_PRIVATE'
}

export type Booking = {
  __typename?: 'Booking';
  amount?: Maybe<Scalars['Float']['output']>;
  canBeRefundedUntil?: Maybe<Scalars['DateTime']['output']>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledBy?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  currency?: Maybe<Currency>;
  details: Array<BookingDetail>;
  didAttend?: Maybe<Scalars['Boolean']['output']>;
  email: Scalars['String']['output'];
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  group: Group;
  guests?: Maybe<Array<Guest>>;
  id: Scalars['ID']['output'];
  isPrivate: Scalars['Boolean']['output'];
  payment?: Maybe<Payment>;
  payments: Array<Payment>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  pickupLocation?: Maybe<PickupLocation>;
  salesPartnerId?: Maybe<Scalars['ID']['output']>;
  sourceBookingId?: Maybe<Scalars['String']['output']>;
  specialRequests?: Maybe<Scalars['String']['output']>;
  state: BookingStatus;
};

export type BookingDetail = {
  __typename?: 'BookingDetail';
  productPrice: ProductPrice;
  quantity: Scalars['Int']['output'];
};

export enum BookingStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Error = 'ERROR',
  New = 'NEW',
  NotAccepted = 'NOT_ACCEPTED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED',
  RefundRequested = 'REFUND_REQUESTED',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED',
  Unavailable = 'UNAVAILABLE'
}

export type BookingsInput = {
  created?: InputMaybe<DateRange>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Order>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  reserved?: InputMaybe<DateRange>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type BookingsResult = {
  __typename?: 'BookingsResult';
  records: Array<Booking>;
  totalRecords: Scalars['Int']['output'];
};

export type CancelBookingInput = {
  cancellationReason: Scalars['String']['input'];
  cancelledByCustomer: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type ConfirmBookingInput = {
  id: Scalars['ID']['input'];
  sendConfirmationEmailToCustomer: Scalars['Boolean']['input'];
};

export type CreateNewBookingInput = {
  currency: Currency;
  customerEmail: Scalars['String']['input'];
  customerPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['Date']['input'];
  details: Array<DetailInput>;
  guests: Array<GuestInput>;
  isPrivate: Scalars['Boolean']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  pickupLocation?: InputMaybe<PickupLocationInput>;
  productId: Scalars['ID']['input'];
  sourceBookingId?: InputMaybe<Scalars['String']['input']>;
  time: Scalars['Time']['input'];
};

export enum Currency {
  Aud = 'AUD',
  Brl = 'BRL',
  Cad = 'CAD',
  Cny = 'CNY',
  Eur = 'EUR',
  Gbp = 'GBP',
  Hkd = 'HKD',
  Ils = 'ILS',
  Inr = 'INR',
  Jpy = 'JPY',
  Krw = 'KRW',
  Myr = 'MYR',
  Nzd = 'NZD',
  Php = 'PHP',
  Sek = 'SEK',
  Sgd = 'SGD',
  Thb = 'THB',
  Twd = 'TWD',
  Usd = 'USD'
}

export type CustomGroupItinerary = {
  __typename?: 'CustomGroupItinerary';
  id: Scalars['ID']['output'];
  stepDescription: Scalars['String']['output'];
  stepOrder: Scalars['Int']['output'];
};

export type DateRange = {
  from?: InputMaybe<Scalars['Date']['input']>;
  until?: InputMaybe<Scalars['Date']['input']>;
};

export type DetailInput = {
  priceTypeId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type DietaryRestriction = {
  __typename?: 'DietaryRestriction';
  diet: Scalars['String']['output'];
  isPossible: YesNoLimited;
  memo?: Maybe<Scalars['String']['output']>;
};

export type EditBookingInput = {
  bookingId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  specialRequests?: InputMaybe<Scalars['String']['input']>;
};

export type EditSalesPartnerInput = {
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  newPassword?: InputMaybe<Scalars['String']['input']>;
  requestDeactivation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GeoLocation = {
  __typename?: 'GeoLocation';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type GeoLocationInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type GoogleMapsQuery = {
  __typename?: 'GoogleMapsQuery';
  created: Scalars['String']['output'];
  geoLocation?: Maybe<GeoLocation>;
  id: Scalars['ID']['output'];
  lastUpdated?: Maybe<Scalars['String']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GoogleMapsQueryInput = {
  geoLocation?: InputMaybe<GeoLocationInput>;
  placeId?: InputMaybe<Scalars['String']['input']>;
};

export type Group = {
  __typename?: 'Group';
  customGroupItinerary?: Maybe<Array<CustomGroupItinerary>>;
  date: Scalars['Date']['output'];
  isPrivate: Scalars['Boolean']['output'];
  product: Product;
  productId: Scalars['ID']['output'];
  time: Scalars['Time']['output'];
};

export type Guest = {
  __typename?: 'Guest';
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
};

export type GuestInput = {
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  index: Scalars['Int']['input'];
};

export type Guide = {
  __typename?: 'Guide';
  id: Scalars['ID']['output'];
  introVideo?: Maybe<Scalars['String']['output']>;
  nickName: Scalars['String']['output'];
  profilePic?: Maybe<Scalars['String']['output']>;
};

export enum Iso639 {
  En = 'en',
  Jp = 'jp',
  Ko = 'ko',
  Th = 'th',
  Zh = 'zh',
  ZhTw = 'zh_tw'
}

export type Location = {
  __typename?: 'Location';
  country: Location;
  countryId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
  translation?: Maybe<LocationTranslation>;
};


export type LocationTranslationArgs = {
  lang: Iso639;
};

export type LocationPickupZone = {
  __typename?: 'LocationPickupZone';
  center: GeoLocation;
  radius: Scalars['Float']['output'];
};

export type LocationTranslation = {
  __typename?: 'LocationTranslation';
  name: Scalars['String']['output'];
};

export enum LocationType {
  City = 'CITY',
  Country = 'COUNTRY',
  Prefecture = 'PREFECTURE',
  Province = 'PROVINCE',
  Region = 'REGION',
  State = 'STATE'
}

export type LocationsInput = {
  countryId?: InputMaybe<Scalars['ID']['input']>;
  hasPublishedProducts?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationType?: InputMaybe<Array<LocationType>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationsResponse = {
  __typename?: 'LocationsResponse';
  records: Array<Location>;
  totalRecords: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  _?: Maybe<Scalars['Boolean']['output']>;
  cancelBooking: Scalars['Boolean']['output'];
  confirmBooking: Scalars['Boolean']['output'];
  createNewBooking: Booking;
  editBooking: Scalars['Boolean']['output'];
  editSalesPartner?: Maybe<Scalars['Boolean']['output']>;
  updatePickupLocation: Scalars['Boolean']['output'];
};


export type MutationCancelBookingArgs = {
  input: CancelBookingInput;
};


export type MutationConfirmBookingArgs = {
  input: ConfirmBookingInput;
};


export type MutationCreateNewBookingArgs = {
  input: CreateNewBookingInput;
};


export type MutationEditBookingArgs = {
  input: EditBookingInput;
};


export type MutationEditSalesPartnerArgs = {
  input?: InputMaybe<EditSalesPartnerInput>;
};


export type MutationUpdatePickupLocationArgs = {
  input: UpdatePickupLocationInput;
};

export type NewsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type NewsResult = {
  __typename?: 'NewsResult';
  records: Array<PartnerPortalNews>;
  totalRecords: Scalars['Int']['output'];
};

export type Order = {
  direction: OrderDirection;
  field: Scalars['String']['input'];
};

export enum OrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type PartnerPortalNews = {
  __typename?: 'PartnerPortalNews';
  date: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  translation?: Maybe<PartnerPortalNewsTranslation>;
};


export type PartnerPortalNewsTranslationArgs = {
  lang: Iso639;
};

export type PartnerPortalNewsTranslation = {
  __typename?: 'PartnerPortalNewsTranslation';
  content: Scalars['String']['output'];
  lang: Iso639;
  title: Scalars['String']['output'];
};

export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['Float']['output'];
  currency: Currency;
  state: Scalars['String']['output'];
};

export type PickupLocation = {
  __typename?: 'PickupLocation';
  address: Scalars['String']['output'];
  name: Scalars['String']['output'];
  query?: Maybe<GoogleMapsQuery>;
};

export type PickupLocationInput = {
  address: Scalars['String']['input'];
  name: Scalars['String']['input'];
  query: GoogleMapsQueryInput;
};

export type Product = {
  __typename?: 'Product';
  availability: Array<ProductAvailability>;
  availabilityType: AvailabilityType;
  currency?: Maybe<Scalars['String']['output']>;
  defaultMaximumInGroup: Scalars['Int']['output'];
  dietaryRestrictions: Array<DietaryRestriction>;
  duration: Scalars['Int']['output'];
  hasAccomodationVehiclePickup: Scalars['Boolean']['output'];
  hasDefaultVehiclePickup: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  inclusions?: Maybe<Array<ProductInclusion>>;
  isCustomTour?: Maybe<Scalars['Boolean']['output']>;
  location: Location;
  mainImage?: Maybe<Scalars['String']['output']>;
  mainPrice: ProductMainPrice;
  mainVideo?: Maybe<Scalars['String']['output']>;
  meetingPlaceGoogleMapsQuery?: Maybe<GoogleMapsQuery>;
  meetingPlaceGoogleMapsUrl?: Maybe<Scalars['String']['output']>;
  minimumInGroup?: Maybe<Scalars['Int']['output']>;
  pickupLocationZone?: Maybe<LocationPickupZone>;
  prices?: Maybe<Array<ProductPrice>>;
  privatePrices?: Maybe<Array<ProductPrivatePrice>>;
  requiresTransportAgreement?: Maybe<Scalars['Boolean']['output']>;
  timeslots: Array<ProductTimeslot>;
  timezone?: Maybe<Scalars['String']['output']>;
  translation?: Maybe<ProductTranslation>;
};


export type ProductAvailabilityArgs = {
  fromDate: Scalars['Date']['input'];
  untilDate: Scalars['Date']['input'];
};


export type ProductMainPriceArgs = {
  currency: Currency;
};


export type ProductPricesArgs = {
  currency: Currency;
};


export type ProductPrivatePricesArgs = {
  currency: Currency;
};


export type ProductTranslationArgs = {
  lang: Iso639;
};

export type ProductAvailability = {
  __typename?: 'ProductAvailability';
  date: Scalars['Date']['output'];
  status: AvailabilityStatus;
  timeSlots?: Maybe<Array<ProductAvailabilityTime>>;
};

export type ProductAvailabilityGroup = {
  __typename?: 'ProductAvailabilityGroup';
  canBecomePublic?: Maybe<Scalars['Boolean']['output']>;
  guides: Array<Guide>;
  id?: Maybe<Scalars['ID']['output']>;
  isAvailable?: Maybe<Scalars['Boolean']['output']>;
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  seatsAvailable: Scalars['Int']['output'];
  seatsAvalable: Scalars['Int']['output'];
};

export type ProductAvailabilityTime = {
  __typename?: 'ProductAvailabilityTime';
  groups?: Maybe<Array<ProductAvailabilityGroup>>;
  status: AvailabilityStatus;
  time: Scalars['Time']['output'];
};

export type ProductInclusion = {
  __typename?: 'ProductInclusion';
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  translation?: Maybe<ProductInclusionTranslation>;
};


export type ProductInclusionTranslationArgs = {
  lang: Iso639;
};

export type ProductInclusionTranslation = {
  __typename?: 'ProductInclusionTranslation';
  description?: Maybe<Scalars['String']['output']>;
  lang: Iso639;
  title: Scalars['String']['output'];
};

export type ProductMainPrice = {
  __typename?: 'ProductMainPrice';
  amount: Scalars['Float']['output'];
  commissionPercentage?: Maybe<Scalars['Float']['output']>;
  currency: Currency;
  id: Scalars['ID']['output'];
  isGroup: Scalars['Boolean']['output'];
};

export enum ProductOrderField {
  LastPublished = 'LAST_PUBLISHED',
  Name = 'NAME',
  Popularity = 'POPULARITY'
}

export type ProductPrice = {
  __typename?: 'ProductPrice';
  amount: Scalars['Float']['output'];
  currency: Currency;
  excludeFromPrivateGroupCount: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  maxAge?: Maybe<Scalars['Int']['output']>;
  minAge: Scalars['Int']['output'];
  minimum: Scalars['Int']['output'];
  tags: Array<Scalars['String']['output']>;
  translation?: Maybe<ProductPriceTranslation>;
};


export type ProductPriceTranslationArgs = {
  lang: Iso639;
};

export type ProductPriceTranslation = {
  __typename?: 'ProductPriceTranslation';
  description?: Maybe<Scalars['String']['output']>;
};

export type ProductPrivatePrice = {
  __typename?: 'ProductPrivatePrice';
  commissionPercentage?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  minGroupSize: Scalars['Int']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  productId: Scalars['ID']['output'];
};

export type ProductTimeslot = {
  __typename?: 'ProductTimeslot';
  dayOfWeek: Scalars['Int']['output'];
  maximumInGroup?: Maybe<Scalars['Int']['output']>;
  timeslot: Scalars['String']['output'];
};

export type ProductTranslation = {
  __typename?: 'ProductTranslation';
  highlights?: Maybe<Scalars['String']['output']>;
  included?: Maybe<Scalars['String']['output']>;
  itinerary?: Maybe<Scalars['String']['output']>;
  meetingPlaceDescription?: Maybe<Scalars['String']['output']>;
  meetingPlaceName?: Maybe<Scalars['String']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  remarks?: Maybe<Scalars['String']['output']>;
};

export type ProductsInput = {
  availabilityTypes?: InputMaybe<Array<AvailabilityType>>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderField?: InputMaybe<ProductOrderField>;
  search?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ProductsResult = {
  __typename?: 'ProductsResult';
  records: Array<Product>;
  totalRecords: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  _?: Maybe<Scalars['Boolean']['output']>;
  booking?: Maybe<Booking>;
  bookings: BookingsResult;
  locations: LocationsResponse;
  news: NewsResult;
  newsArticle?: Maybe<PartnerPortalNews>;
  product?: Maybe<Product>;
  products: ProductsResult;
  salesPartner?: Maybe<SalesPartner>;
  tags: TagsResponse;
};


export type QueryBookingArgs = {
  id: Scalars['ID']['input'];
  state?: InputMaybe<BookingStatus>;
};


export type QueryBookingsArgs = {
  input: BookingsInput;
};


export type QueryLocationsArgs = {
  input?: InputMaybe<LocationsInput>;
};


export type QueryNewsArgs = {
  input?: InputMaybe<NewsInput>;
};


export type QueryNewsArticleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductsArgs = {
  input?: InputMaybe<ProductsInput>;
};


export type QueryTagsArgs = {
  input?: InputMaybe<TagsInput>;
};

export type SalesPartner = {
  __typename?: 'SalesPartner';
  countryId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  hasPartnerPortalAccess: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Tag = {
  __typename?: 'Tag';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  translation?: Maybe<TagTranslation>;
};


export type TagTranslationArgs = {
  lang: Iso639;
};

export type TagTranslation = {
  __typename?: 'TagTranslation';
  name: Scalars['String']['output'];
};

export type TagsInput = {
  hasPublishedProducts?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type TagsResponse = {
  __typename?: 'TagsResponse';
  records: Array<Tag>;
  totalRecords: Scalars['Int']['output'];
};

export type UpdatePickupLocationInput = {
  bookingId: Scalars['ID']['input'];
  pickupLocation: PickupLocationInput;
  sendEmailToCustomer?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum YesNoLimited {
  Limited = 'limited',
  No = 'no',
  Yes = 'yes'
}

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __Type = {
  __typename?: '__Type';
  kind: __TypeKind;
  name?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  specifiedByURL?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<__Field>>;
  interfaces?: Maybe<Array<__Type>>;
  possibleTypes?: Maybe<Array<__Type>>;
  enumValues?: Maybe<Array<__EnumValue>>;
  inputFields?: Maybe<Array<__InputValue>>;
  ofType?: Maybe<__Type>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeEnumValuesArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeInputFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An enum describing what kind of type a given `__Type` is. */
export enum __TypeKind {
  /** Indicates this type is a scalar. */
  Scalar = 'SCALAR',
  /** Indicates this type is an object. `fields` and `interfaces` are valid fields. */
  Object = 'OBJECT',
  /** Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields. */
  Interface = 'INTERFACE',
  /** Indicates this type is a union. `possibleTypes` is a valid field. */
  Union = 'UNION',
  /** Indicates this type is an enum. `enumValues` is a valid field. */
  Enum = 'ENUM',
  /** Indicates this type is an input object. `inputFields` is a valid field. */
  InputObject = 'INPUT_OBJECT',
  /** Indicates this type is a list. `ofType` is a valid field. */
  List = 'LIST',
  /** Indicates this type is a non-null. `ofType` is a valid field. */
  NonNull = 'NON_NULL'
}

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __Field = {
  __typename?: '__Field';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  args: Array<__InputValue>;
  type: __Type;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};


/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __FieldArgsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value. */
export type __InputValue = {
  __typename?: '__InputValue';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  type: __Type;
  /** A GraphQL-formatted string representing the default value for this input value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};

/** One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string. */
export type __EnumValue = {
  __typename?: '__EnumValue';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};

export type GetCitiesQueryVariables = Exact<{
  countryId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetCitiesQuery = { __typename?: 'Query', locations: { __typename?: 'LocationsResponse', records: Array<{ __typename?: 'Location', id: string, slug: string }> } };

export type GetCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesQuery = { __typename?: 'Query', locations: { __typename?: 'LocationsResponse', records: Array<{ __typename?: 'Location', id: string, slug: string }> } };

export type UpdatePickupLocationMutationVariables = Exact<{
  input: UpdatePickupLocationInput;
}>;


export type UpdatePickupLocationMutation = { __typename?: 'Mutation', updatePickupLocation: boolean };

export type GetProductsForSelectorQueryVariables = Exact<{
  orderField?: InputMaybe<ProductOrderField>;
}>;


export type GetProductsForSelectorQuery = { __typename?: 'Query', products: { __typename?: 'ProductsResult', records: Array<{ __typename?: 'Product', id: string, translation?: { __typename?: 'ProductTranslation', name: string } | null }> } };

export type GetTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTagsQuery = { __typename?: 'Query', tags: { __typename?: 'TagsResponse', records: Array<{ __typename?: 'Tag', id: string, name: string }> } };

export type GetCurrenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrenciesQuery = { __typename?: 'Query', __type?: { __typename?: '__Type', enumValues?: Array<{ __typename?: '__EnumValue', name: string }> | null } | null };

export type GetSalesPartnerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSalesPartnerQuery = { __typename?: 'Query', salesPartner?: { __typename?: 'SalesPartner', id: string, name: string, email: string } | null };

export type EditSalesPartnerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  newPassword?: InputMaybe<Scalars['String']['input']>;
  requestDeactivation?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EditSalesPartnerMutation = { __typename?: 'Mutation', editSalesPartner?: boolean | null };

export type CancelBookingMutationVariables = Exact<{
  input: CancelBookingInput;
}>;


export type CancelBookingMutation = { __typename?: 'Mutation', cancelBooking: boolean };

export type EditBookingMutationVariables = Exact<{
  input: EditBookingInput;
}>;


export type EditBookingMutation = { __typename?: 'Mutation', editBooking: boolean };

export type GetBookingsQueryVariables = Exact<{
  input: BookingsInput;
  lang: Iso639;
}>;


export type GetBookingsQuery = { __typename?: 'Query', bookings: { __typename?: 'BookingsResult', totalRecords: number, records: Array<{ __typename?: 'Booking', id: string, created: any, didAttend?: boolean | null, state: BookingStatus, email: string, phoneNumber?: string | null, specialRequests?: string | null, sourceBookingId?: string | null, salesPartnerId?: string | null, canBeRefundedUntil?: any | null, cancelledBy?: string | null, cancellationReason?: string | null, guests?: Array<{ __typename?: 'Guest', givenName: string, familyName: string }> | null, group: { __typename?: 'Group', date: any, time: any, product: { __typename?: 'Product', availabilityType: AvailabilityType, hasAccomodationVehiclePickup: boolean, hasDefaultVehiclePickup: boolean, requiresTransportAgreement?: boolean | null, translation?: { __typename?: 'ProductTranslation', name: string, meetingPlaceName?: string | null } | null, location: { __typename?: 'Location', timezone?: string | null }, meetingPlaceGoogleMapsQuery?: { __typename?: 'GoogleMapsQuery', id: string, placeId?: string | null, geoLocation?: { __typename?: 'GeoLocation', lat: number, lng: number } | null } | null, pickupLocationZone?: { __typename?: 'LocationPickupZone', radius: number, center: { __typename?: 'GeoLocation', lat: number, lng: number } } | null } }, details: Array<{ __typename?: 'BookingDetail', quantity: number, productPrice: { __typename?: 'ProductPrice', minAge: number, maxAge?: number | null, tags: Array<string> } }>, pickupLocation?: { __typename?: 'PickupLocation', name: string, address: string, query?: { __typename?: 'GoogleMapsQuery', placeId?: string | null, geoLocation?: { __typename?: 'GeoLocation', lat: number, lng: number } | null } | null } | null, payment?: { __typename?: 'Payment', state: string, amount: number, currency: Currency } | null }> } };

export type GetBookingForTsaQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBookingForTsaQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', created: any, currency?: Currency | null, amount?: number | null, payments: Array<{ __typename?: 'Payment', state: string, amount: number }>, details: Array<{ __typename?: 'BookingDetail', quantity: number }>, pickupLocation?: { __typename?: 'PickupLocation', name: string, address: string, query?: { __typename?: 'GoogleMapsQuery', placeId?: string | null, geoLocation?: { __typename?: 'GeoLocation', lat: number, lng: number } | null } | null } | null, group: { __typename?: 'Group', time: any, date: any, customGroupItinerary?: Array<{ __typename?: 'CustomGroupItinerary', id: string, stepDescription: string, stepOrder: number }> | null, product: { __typename?: 'Product', isCustomTour?: boolean | null, minimumInGroup?: number | null, meetingPlaceGoogleMapsUrl?: string | null, translation?: { __typename?: 'ProductTranslation', name: string, itinerary?: string | null, meetingPlaceName?: string | null, meetingPlaceDescription?: string | null } | null } } } | null };

export type GetNewsArticleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetNewsArticleQuery = { __typename?: 'Query', newsArticle?: { __typename?: 'PartnerPortalNews', id: string, date: any, imageUrl: string, translation?: { __typename?: 'PartnerPortalNewsTranslation', title: string, content: string } | null } | null };

export type GetNewsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetNewsQuery = { __typename?: 'Query', news: { __typename?: 'NewsResult', totalRecords: number, records: Array<{ __typename?: 'PartnerPortalNews', id: string, date: any, imageUrl: string, translation?: { __typename?: 'PartnerPortalNewsTranslation', title: string, content: string } | null }> } };

export type GetProductQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
  lang: Iso639;
  currency: Currency;
}>;


export type GetProductQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, availabilityType: AvailabilityType, defaultMaximumInGroup: number, duration: number, mainImage?: string | null, mainVideo?: string | null, hasAccomodationVehiclePickup: boolean, hasDefaultVehiclePickup: boolean, dietaryRestrictions: Array<{ __typename?: 'DietaryRestriction', diet: string, isPossible: YesNoLimited, memo?: string | null }>, location: { __typename?: 'Location', timezone?: string | null, countryId: string }, timeslots: Array<{ __typename?: 'ProductTimeslot', dayOfWeek: number, timeslot: string, maximumInGroup?: number | null }>, translation?: { __typename?: 'ProductTranslation', name: string, highlights?: string | null, included?: string | null, itinerary?: string | null, meetingPlaceName?: string | null, remarks?: string | null } | null, prices?: Array<{ __typename?: 'ProductPrice', id: string, amount: number, currency: Currency, minimum: number, minAge: number, maxAge?: number | null, tags: Array<string>, excludeFromPrivateGroupCount: boolean, translation?: { __typename?: 'ProductPriceTranslation', description?: string | null } | null }> | null, privatePrices?: Array<{ __typename?: 'ProductPrivatePrice', id: string, minGroupSize: number, price?: number | null }> | null, inclusions?: Array<{ __typename?: 'ProductInclusion', id: string, index: number, icon?: string | null, translation?: { __typename?: 'ProductInclusionTranslation', lang: Iso639, title: string, description?: string | null } | null }> | null, meetingPlaceGoogleMapsQuery?: { __typename?: 'GoogleMapsQuery', id: string, lastUpdated?: string | null, url?: string | null, placeId?: string | null, geoLocation?: { __typename?: 'GeoLocation', lat: number, lng: number } | null } | null, pickupLocationZone?: { __typename?: 'LocationPickupZone', radius: number, center: { __typename?: 'GeoLocation', lat: number, lng: number } } | null } | null };

export type CreateNewBookingMutationVariables = Exact<{
  input: CreateNewBookingInput;
}>;


export type CreateNewBookingMutation = { __typename?: 'Mutation', createNewBooking: { __typename?: 'Booking', id: string } };

export type GetLatestNewsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestNewsQuery = { __typename?: 'Query', news: { __typename?: 'NewsResult', records: Array<{ __typename?: 'PartnerPortalNews', id: string, date: any, translation?: { __typename?: 'PartnerPortalNewsTranslation', title: string, content: string } | null }> } };

export type GetNewProductsQueryVariables = Exact<{
  input?: InputMaybe<ProductsInput>;
  lang: Iso639;
  currency: Currency;
}>;


export type GetNewProductsQuery = { __typename?: 'Query', products: { __typename?: 'ProductsResult', totalRecords: number, records: Array<{ __typename?: 'Product', id: string, duration: number, mainImage?: string | null, translation?: { __typename?: 'ProductTranslation', name: string, metaDescription?: string | null } | null, location: { __typename?: 'Location', translation?: { __typename?: 'LocationTranslation', name: string } | null, country: { __typename?: 'Location', translation?: { __typename?: 'LocationTranslation', name: string } | null } }, mainPrice: { __typename?: 'ProductMainPrice', amount: number, currency: Currency, isGroup: boolean } }> } };

export type GetProductsQueryVariables = Exact<{
  input?: InputMaybe<ProductsInput>;
  lang: Iso639;
  currency: Currency;
}>;


export type GetProductsQuery = { __typename?: 'Query', products: { __typename?: 'ProductsResult', totalRecords: number, records: Array<{ __typename?: 'Product', id: string, duration: number, mainImage?: string | null, availabilityType: AvailabilityType, translation?: { __typename?: 'ProductTranslation', name: string, metaDescription?: string | null } | null, location: { __typename?: 'Location', translation?: { __typename?: 'LocationTranslation', name: string } | null }, mainPrice: { __typename?: 'ProductMainPrice', amount: number, currency: Currency, isGroup: boolean } }> } };

export type GetProductAvailabilityQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
  fromDate: Scalars['Date']['input'];
  untilDate: Scalars['Date']['input'];
}>;


export type GetProductAvailabilityQuery = { __typename?: 'Query', product?: { __typename?: 'Product', availability: Array<{ __typename?: 'ProductAvailability', date: any, status: AvailabilityStatus, timeSlots?: Array<{ __typename?: 'ProductAvailabilityTime', time: any, status: AvailabilityStatus, groups?: Array<{ __typename?: 'ProductAvailabilityGroup', seatsAvailable: number, isPrivate?: boolean | null, isEmpty?: boolean | null }> | null }> | null }> } | null };


export const GetCitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"countryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locationType"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"PREFECTURE"},{"kind":"EnumValue","value":"CITY"}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"hasPublishedProducts"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<GetCitiesQuery, GetCitiesQueryVariables>;
export const GetCountriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCountries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"locationType"},"value":{"kind":"EnumValue","value":"COUNTRY"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<GetCountriesQuery, GetCountriesQueryVariables>;
export const UpdatePickupLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePickupLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePickupLocationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePickupLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdatePickupLocationMutation, UpdatePickupLocationMutationVariables>;
export const GetProductsForSelectorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProductsForSelector"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderField"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductOrderField"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"orderField"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderField"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"EnumValue","value":"en"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProductsForSelectorQuery, GetProductsForSelectorQueryVariables>;
export const GetTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hasPublishedProducts"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetTagsQuery, GetTagsQueryVariables>;
export const GetCurrenciesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__type"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"Currency","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enumValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetCurrenciesQuery, GetCurrenciesQueryVariables>;
export const GetSalesPartnerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSalesPartner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"salesPartner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<GetSalesPartnerQuery, GetSalesPartnerQueryVariables>;
export const EditSalesPartnerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditSalesPartner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentPassword"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newPassword"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requestDeactivation"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editSalesPartner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"currentPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentPassword"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"newPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newPassword"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"requestDeactivation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requestDeactivation"}}}]}}]}]}}]} as unknown as DocumentNode<EditSalesPartnerMutation, EditSalesPartnerMutationVariables>;
export const CancelBookingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelBooking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CancelBookingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelBooking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<CancelBookingMutation, CancelBookingMutationVariables>;
export const EditBookingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditBooking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditBookingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editBooking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<EditBookingMutation, EditBookingMutationVariables>;
export const GetBookingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBookings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingsInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Iso639"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bookings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalRecords"}},{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"didAttend"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"specialRequests"}},{"kind":"Field","name":{"kind":"Name","value":"sourceBookingId"}},{"kind":"Field","name":{"kind":"Name","value":"salesPartnerId"}},{"kind":"Field","name":{"kind":"Name","value":"canBeRefundedUntil"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledBy"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationReason"}},{"kind":"Field","name":{"kind":"Name","value":"guests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"meetingPlaceName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availabilityType"}},{"kind":"Field","name":{"kind":"Name","value":"hasAccomodationVehiclePickup"}},{"kind":"Field","name":{"kind":"Name","value":"hasDefaultVehiclePickup"}},{"kind":"Field","name":{"kind":"Name","value":"requiresTransportAgreement"}},{"kind":"Field","name":{"kind":"Name","value":"meetingPlaceGoogleMapsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"placeId"}},{"kind":"Field","name":{"kind":"Name","value":"geoLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pickupLocationZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"center"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"radius"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"productPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minAge"}},{"kind":"Field","name":{"kind":"Name","value":"maxAge"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pickupLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"placeId"}},{"kind":"Field","name":{"kind":"Name","value":"geoLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBookingsQuery, GetBookingsQueryVariables>;
export const GetBookingForTsaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBookingForTsa"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"booking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pickupLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"placeId"}},{"kind":"Field","name":{"kind":"Name","value":"geoLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"customGroupItinerary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stepDescription"}},{"kind":"Field","name":{"kind":"Name","value":"stepOrder"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isCustomTour"}},{"kind":"Field","name":{"kind":"Name","value":"minimumInGroup"}},{"kind":"Field","name":{"kind":"Name","value":"meetingPlaceGoogleMapsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"EnumValue","value":"en"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"itinerary"}},{"kind":"Field","name":{"kind":"Name","value":"meetingPlaceName"}},{"kind":"Field","name":{"kind":"Name","value":"meetingPlaceDescription"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBookingForTsaQuery, GetBookingForTsaQueryVariables>;
export const GetNewsArticleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNewsArticle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newsArticle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"EnumValue","value":"en"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]}}]} as unknown as DocumentNode<GetNewsArticleQuery, GetNewsArticleQueryVariables>;
export const GetNewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNews"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"news"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalRecords"}},{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"EnumValue","value":"en"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetNewsQuery, GetNewsQueryVariables>;
export const GetProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Iso639"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Currency"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"availabilityType"}},{"kind":"Field","name":{"kind":"Name","value":"defaultMaximumInGroup"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"}},{"kind":"Field","name":{"kind":"Name","value":"mainVideo"}},{"kind":"Field","name":{"kind":"Name","value":"dietaryRestrictions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"diet"}},{"kind":"Field","name":{"kind":"Name","value":"isPossible"}},{"kind":"Field","name":{"kind":"Name","value":"memo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"countryId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeslots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"timeslot"}},{"kind":"Field","name":{"kind":"Name","value":"maximumInGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}},{"kind":"Field","name":{"kind":"Name","value":"included"}},{"kind":"Field","name":{"kind":"Name","value":"itinerary"}},{"kind":"Field","name":{"kind":"Name","value":"meetingPlaceName"}},{"kind":"Field","name":{"kind":"Name","value":"remarks"}}]}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"currency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"minimum"}},{"kind":"Field","name":{"kind":"Name","value":"minAge"}},{"kind":"Field","name":{"kind":"Name","value":"maxAge"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"excludeFromPrivateGroupCount"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"privatePrices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"currency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"minGroupSize"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inclusions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meetingPlaceGoogleMapsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"placeId"}},{"kind":"Field","name":{"kind":"Name","value":"geoLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasAccomodationVehiclePickup"}},{"kind":"Field","name":{"kind":"Name","value":"hasDefaultVehiclePickup"}},{"kind":"Field","name":{"kind":"Name","value":"pickupLocationZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"center"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"radius"}}]}}]}}]}}]} as unknown as DocumentNode<GetProductQuery, GetProductQueryVariables>;
export const CreateNewBookingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateNewBooking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateNewBookingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createNewBooking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateNewBookingMutation, CreateNewBookingMutationVariables>;
export const GetLatestNewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLatestNews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"news"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}},{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"3"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"EnumValue","value":"en"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLatestNewsQuery, GetLatestNewsQueryVariables>;
export const GetNewProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNewProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductsInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Iso639"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Currency"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalRecords"}},{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"metaDescription"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mainPrice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"currency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"isGroup"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetNewProductsQuery, GetNewProductsQueryVariables>;
export const GetProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductsInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Iso639"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Currency"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalRecords"}},{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"}},{"kind":"Field","name":{"kind":"Name","value":"availabilityType"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"metaDescription"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mainPrice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"currency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"isGroup"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProductsQuery, GetProductsQueryVariables>;
export const GetProductAvailabilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProductAvailability"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"untilDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availability"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fromDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"untilDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"untilDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"timeSlots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seatsAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"isPrivate"}},{"kind":"Field","name":{"kind":"Name","value":"isEmpty"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProductAvailabilityQuery, GetProductAvailabilityQueryVariables>;